
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';
import Bugsnag from '@bugsnag/js';
import PropTypes from 'prop-types';
import { AVATAR_LOCAL_IMAGE } from '@constants/avatar-maker';
import { ProfileRootContentType } from '@utils/propTypes';
import { removeFileExtension } from '@utils/index';
import { awaitFetchContent } from '@/src/utils/contentfulHelpers';
import ProfileLayout from '../../components/ProfileLayout';
import SegmentPage from '../../components/SegmentPage';
import ContentModal from './components/ContentModal';
import { setProfileData, setDefaultWandData, setUserWandImage, useGlobalState, setUserPatronusImage, setUserAvatarImage, setUserInterestsData, setSelectedUserInterests, } from '../../globalStates/ProfileState';
import { ERROR_404 } from '../../constants/routes';
import { useUserContext } from '../../contexts/user-context';
import useProfileRouter from '../../hooks/useProfileRouter';
import Loaders from '../../components/Loaders';
import loaderTypes from '../../components/Loaders/loaderTypes';
import s from './Profile.module.scss';
const propTypes = {
    children: PropTypes.node,
    path: PropTypes.array,
    activeModal: PropTypes.bool,
    hideMobile: PropTypes.bool,
    pageName: PropTypes.string,
    modalTheme: PropTypes.string,
    rootContent: ProfileRootContentType
};
const Profile = ({ children = null, path = [], activeModal = false, hideMobile = false, pageName = 'Profile', modalTheme = 'dark', rootContent = null, }) => {
    const userInterestsEnabled = process.env.REACT_APP_USER_INTERESTS_ENABLED === 'TRUE';
    const router = useRouter();
    useProfileRouter(path.join('/'));
    const { loading, loadingProfile, profile } = useUserContext();
    const [profileData] = useGlobalState('profileData');
    const [theme, setTheme] = useState(null);
    useEffect(() => {
        const loadProfileContent = async () => {
            // The profile will get rendered even for anon users before they are redirected
            // by the profileRouter to login. This prevents an empty profile state from being
            // saved to profileData WWD-4286
            if (isEmpty(profile))
                return;
            const { wand, patronusFileName, interests } = profile;
            const { wandIndex, wandImages, patronusImages } = rootContent;
            /* istanbul ignore next */
            const userInterestsData = userInterestsEnabled ? rootContent.userInterestsData : undefined;
            try {
                setDefaultWandData(wandIndex);
                const wandData = wandIndex;
                // Find and load the user's wand image
                if (wand && wandData) {
                    const { woodList, lengthList, flexibilityList } = wandData;
                    const { length, wood, flexibility } = wand;
                    const wandExternalId = `wand-${woodList[wood].type}-${lengthList[length].type}-${flexibilityList[flexibility]?.type}_handle`;
                    const wandImage = wandImages[wandExternalId];
                    if (wandImage)
                        setUserWandImage(wandImage);
                }
                // Find and load the user's patronus image
                if (patronusFileName) {
                    const patronusImage = patronusImages[removeFileExtension(patronusFileName)];
                    if (patronusImage)
                        setUserPatronusImage(patronusImage);
                }
                // Find and load the user's interests
                if (userInterestsEnabled && userInterestsData) {
                    setUserInterestsData(userInterestsData);
                    if (interests) {
                        setSelectedUserInterests(userInterestsData.filter((item) => interests.some((interest) => interest.interestContentfulId === item.contentfulId)));
                    }
                }
                // Fetch and load the profile page associated with the user's house
                const house = profile.hogwartsHouse || 'no-house';
                const profilePageExternalId = `profile-${house.toLowerCase()}`;
                const profilePage = await awaitFetchContent('profilePage', profilePageExternalId);
                if (profilePage) {
                    setProfileData(profilePage);
                }
                else {
                    throw new Error('Missing profile page data');
                }
            }
            catch (e) /* istanbul ignore next */ {
                Bugsnag.notify(e);
                router.push(ERROR_404);
            }
        };
        /* istanbul ignore else */
        if (!loadingProfile && !profileData && rootContent) {
            loadProfileContent();
            if (profile.avatar) {
                // If the user has an avatar but no url, then fall back to local version
                // while the backend renders the completed avatar.
                if (profile.avatar.url) {
                    setUserAvatarImage(profile.avatar.url);
                    localStorage.removeItem(AVATAR_LOCAL_IMAGE);
                }
                else {
                    setUserAvatarImage(localStorage.getItem(AVATAR_LOCAL_IMAGE));
                }
            }
        }
    }, [
        loadingProfile,
        profileData,
        profile.hogwartsHouse,
        profile.avatar,
        profile,
        router,
        rootContent,
        modalTheme,
        userInterestsEnabled,
    ]);
    useEffect(() => {
        if (modalTheme === 'user-house') {
            setTheme(profile.hogwartsHouse ? `user-${profile.hogwartsHouse.toLowerCase()}` : 'user-no-house');
        }
        else {
            setTheme(modalTheme);
        }
    }, [modalTheme, profile, profile.hogwartsHouse]);
    if (loading || loadingProfile || !profileData) {
        return (<div className={s.profilePageLoader}>
        <Loaders type={loaderTypes.timeturner}/>
      </div>);
    }
    return (<ProfileLayout location={pageName} path={path.join('/')} activeModal={activeModal} hideMobile={hideMobile}>
      <SegmentPage key={pageName} pageName={pageName}/>
      {children && <ContentModal theme={theme}>{children}</ContentModal>}
    </ProfileLayout>);
};
Profile.propTypes = propTypes;
export default Profile;

    async function __Next_Translate__getStaticProps__195ca0c9e3e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0c9e3e__ as getStaticProps }
  